export interface LaoNumber {
  laoChar: string;
  arabicNum: number;
  name: string;
  emoji: string;
  emojiCount: string;
  answer: string[];
  soundFile: string;
  color: string;
}

export const numbers: LaoNumber[] = [
  { laoChar: '໑', arabicNum: 1, name: 'ໜຶ່ງ', emoji: '🍎', emojiCount: '🍎', answer: ['ໜ', 'ຶ', '່', 'ງ'], soundFile: 'sounds/numbers/1.mp3', color: 'bg-red-400' },
  { laoChar: '໒', arabicNum: 2, name: 'ສອງ', emoji: '🍎', emojiCount: '🍎🍎', answer: ['ສ', 'ອ', 'ງ'], soundFile: 'sounds/numbers/2.mp3', color: 'bg-orange-400' },
  { laoChar: '໓', arabicNum: 3, name: 'ສາມ', emoji: '🍎', emojiCount: '🍎🍎🍎', answer: ['ສ', 'າ', 'ມ'], soundFile: 'sounds/numbers/3.mp3', color: 'bg-yellow-400' },
  { laoChar: '໔', arabicNum: 4, name: 'ສີ່', emoji: '🍎', emojiCount: '🍎🍎🍎🍎', answer: ['ສ', 'ີ', '່'], soundFile: 'sounds/numbers/4.mp3', color: 'bg-green-400' },
  { laoChar: '໕', arabicNum: 5, name: 'ຫ້າ', emoji: '🍎', emojiCount: '🍎🍎🍎🍎🍎', answer: ['ຫ', '້', 'າ'], soundFile: 'sounds/numbers/5.mp3', color: 'bg-teal-400' },
  { laoChar: '໖', arabicNum: 6, name: 'ຫົກ', emoji: '🍎', emojiCount: '🍎🍎🍎🍎🍎🍎', answer: ['ຫ', 'ົ', 'ກ'], soundFile: 'sounds/numbers/6.mp3', color: 'bg-blue-400' },
  { laoChar: '໗', arabicNum: 7, name: 'ເຈັດ', emoji: '🍎', emojiCount: '🍎🍎🍎🍎🍎🍎🍎', answer: ['ເ', 'ຈ', 'ັ', 'ດ'], soundFile: 'sounds/numbers/7.mp3', color: 'bg-indigo-400' },
  { laoChar: '໘', arabicNum: 8, name: 'ແປດ', emoji: '🍎', emojiCount: '🍎🍎🍎🍎🍎🍎🍎🍎', answer: ['ແ', 'ປ', 'ດ'], soundFile: 'sounds/numbers/8.mp3', color: 'bg-purple-400' },
  { laoChar: '໙', arabicNum: 9, name: 'ເກົ້າ', emoji: '🍎', emojiCount: '🍎🍎🍎🍎🍎🍎🍎🍎🍎', answer: ['ເ', 'ກ', 'ົ', '້', 'າ'], soundFile: 'sounds/numbers/9.mp3', color: 'bg-pink-400' },
  { laoChar: '໑໐', arabicNum: 10, name: 'ສິບ', emoji: '🍎', emojiCount: '🍎🍎🍎🍎🍎🍎🍎🍎🍎🍎', answer: ['ສ', 'ິ', 'ບ'], soundFile: 'sounds/numbers/10.mp3', color: 'bg-rose-400' },
];
